/* eslint-disable max-len */
export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  SEARCH_PAGE: "search-page",
  SEARCH_PAGE_OLD: "search-page-old",
  ALL_MAGAZINES_LISTING_PAGE: "all-magazines-listing-page",
  STORY_PAGE: "story-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  AUTHOR_PAGE: "author-page",
  SUBSCRIPTION_PAGE: "subscription-page",
  RESET_PASSWORD_PAGE: "reset-password-page",
  PROFILE_PAGE: "profile-page",
  USER_LOGIN: "user-login",
  VISUAL_STORY: "visual-story",
  ALL_RANKINGS: "all-rankings",
  ALL_COMPANIES: "all-companies",
  MOST_POWERFUL_WOMEN: "most-powerful-women",
  FORTY_UNDER_40: "40-under-40",
  AUTHORS_LIST: "authors-list",
  ATOM_REF: "atom-reference",
  TOP15_RANKINGS: "top15-rankings",
  PEOPLE_RANKING: "people-ranking",
  INDIVIDUAL_PAGE: "individual-page",
  RANKINGS_TABLE: "rankings-table",
  FORTUNE_500: "fortune-500",
  THE_NEXT_500: "the-next-500",
  MAGAZINES_ISSUE_LANDING_PAGE: "magazines-issue-landing-page",
  COMPANY_PAGE: "company-page",
  SUMMARY_PAGE: "summary-page",
  BEST_B_SCHOOLS_DETAIL: "best-b-schools-detail",
  MNC_500_DETAIL: "mnc-500-detail",
  CUSTOM_EVENT_PAGE: "custom-event-page",
  THE_EMERGING_COMPANIES: "the-emerging-companies",
  SUBSCRIPTION_SUCCESS: "subscription-success",
  SUBSCRIPTION_FAILURE: "subscription-failure",
  YTSHORTS_PAGE: "ytshorts-page",
  YTSHORTS_DETAIL_PAGE: "ytshorts-detail-page",
  TOP100_BILLIONAIRES: "indias-top-billionaires",
});

export const CACHEABLE_PAGE_TYPES = [
  "all-rankings",
  "all-companies",
  "most-powerful-women",
  "40-under-40",
  "top15-rankings",
  "people-ranking",
  "individual-page",
  "rankings-table",
  "fortune-500",
  "the-next-500",
  "company-page",
  "best-b-schools-detail",
  "mnc-500-detail",
  "custom-event-page",
];

export const TAG_PAGE_URL_PREFIX = "/topic/";

export const storyFields =
  "headline,subheadline,sections,story-template,author-name,authors,hero-image-metadata,hero-image-s3-key,slug,id,last-published-at,first-published-at";

export const STORY_FIELDS =
  "id,metadata,story-template,headline,sections,slug,hero-image-s3-key,hero-image-metadata,author-name,author-id,authors,url,alternative,last-published-at,first-published-at,hero-image-caption,read-time";
export const RELATED_STORY_FIELDS =
  "id,headline,hero-image-s3-key,hero-image-metadata,hero-image-alt-text,slug,url,story-template";
export const SUMMARY_STORY_FIELDS =
  "id,metadata,story-template,headline,cards,sections,slug,hero-image-s3-key,hero-image-metadata,author-name,author-id,authors,url,alternative,last-published-at,first-published-at,hero-image-caption,read-time,published-at,assignee-name,public-identifier,sequence-no";

export const TRENDING_STORY_FIELDS = ["headline", "slug"];
export const STATIC_KEYWORDS = Object.freeze({
  SIGN_IN: "Sign In",
  GO_AD_FREE: "Go Ad-Free",
  MENU_ITEM: "Menu Item",
  SUB_MENU: "Sub Menu",
  FOLLOW_FACEBOOK: "Follow Facebook",
  FOLLOW_X: "Follow X",
  FOLLOW_YOUTUBE: "Follow Youtube",
  FOLLOW_INSTAGRAM: "Follow Instagram",
  FORTUNE_DESCRIPTION:
    "Published by the RP-Sanjiv Goenka Group, Fortune India - the Indian edition of Fortune magazine - sets the benchmark for editorial excellence and thought leadership in Indian business journalism.",
  ADVERTISEMENT: "ADVERTISEMENT",
  LISTEN: "Listen",
  SUMMARY: "Summary",
  READ_TIME_STRING: "min read",
  BREAKING_NEWS_LABEL: "Just In",
  SUBSCRIBE: "Subscribe",
  ANNUAL_SUBSCRIPTION: "Annual Subscription",
  AUTHORS: "Authors",
  LOAD_MORE: "Load More",
  SEARCH: "Search",
  NO_RESULT_FOUND: "Oops! We couldn’t find any results for ",
  TRY_AGAIN: "Please try again.",
  ALSO_READ: "Also Read",
  FULL_STORY: "Full Story",
  VIEW_ALL_SUMMARIES: "View all Summaries",
  AI_WARNING:
    "This summary is AI-generated, and Fortune India is not responsible for its content or any associated copyright issues.",
  POWERED_BY: "Powered by",
  RECOMMENDED_STORIES: "Recommended Stories",
  MORE_STORIES_FROM_ISSUE: "More Stories from this Issue",
  TRENDING_STORIES: "Trending Stories",
  HIGHLIGHTS: "Highlights",
  VIEW_FULL_LIST: "View Full List",
  ALL: "All",
  NEWS: "News",
  EXPLORE_LATEST_LIST: "Explore Latest List",
  EXPLORE_FULL_LIST: "Explore Full List",
  SNAPSHOT: "Snapshot",
  READ_MORE: "Read More",
  READ_LESS: "Read Less",
  READ_NOW: "Read Now",
  SEE_MORE: "See More",
  SEE_LESS: "See Less",
  EXPANDED: "expanded",
  SHARE_STORY: "Share this story",
  GO_AD_FREE_BLACK_DESCRIPTION_SIGN_UP: "Sign up for Fortune India's ad-free experience",
  GO_AD_FREE_BLACK_DESCRIPTION_ENJOY: "Enjoy uninterrupted access to premium content and insights.",
  ALL_COMPANIES: "All Companies",
  PEOPLE: "People",
  SIGN_UP_LABEL: "Sign In or Register",
  PROFILES_MENTIONED: "Profiles Mentioned in this article",
  IN_THIS_STORY: "In this story",
  SIGN_UP_DESCRIPTION:
    "A subscription is required to access and enjoy all the magazines available. Sign in to continue your journey or create an account to join our thriving community.",
  SING_IN_VIA: "Sign in via",
  CONTINUE_WITH: "CONTINUE WITH",
  READ_FULL_E_MAGAZINE: "Read Full E-Magazine",
  ENTER_EMAIL: "Enter Email or Phone Number",
  CONTINUE: "Continue",
  TERMS_PRE_TEXT: "By continuing, you agree to Fortune India’s",
  TERMS_AND_CONDITIONS: "Terms & Conditions",
  PRIVACY_POLICY: "Privacy Policy",
  RELATED_TAGS: "Related Tags",
  OVERVIEW: "OVERVIEW",
  FINANCIALS: "FINANCIALS",
  NEWS_CAPITAL: "NEWS",
  ABOUT_PROFILE: "About",
  PROFILE_ORGANIZATION: "Organization:",
  PROFILE_AGE: "Age:",
  FEATURED_IN: "Featured In Fortune India Ranking",
  MORE: "More",
  FORTUNE_INDIA_MAGAZINE: "Fortune India Magazine",
  NO_MAGAZINE_ISSUES_FOUND: "NO MAGAZINE ISSUES FOUND",
  SELECT_YEAR_AND_MONTHS: "Select Year and Months",
  READ_EMAGAZINE_BLACK: "Experience an immersive reading journey on our all-new digital platform.",
  READ_EMAGAZINE: "Read E-Magazine",
  WELCOME: "Welcome To",
  FORTUNE_SUMMARIES: "Fortune India Summaries",
  SUMMARY_SUBTITLE: "The day's news served in quick, bite-sized updates",
  SELECT_CATEGORY: "Select Categories",
  SPONSORED: "SPONSORED FEATURE",
  THIS_STORY_FEATURES: "THIS STORY FEATURES",
  NEWSLETTER_HEADING: "Stay ahead with exclusive business insights with weekly newsletter!",
  EMAIL_LABEL: "Enter your email",
  EMAIL_PLACEHOLDER: "abc@mail.com",
  SUBSCRIBE: "Subscribe",
  SUBSCRIBING: "Subscribing...",
  ALREADY_SUBSCRIBED_MESSAGE: "You're already subscribed!",
  SUBSCRIPTION_SUCCESS_MESSAGE: "You're successfully subscribed!",
  INVALID_EMAIL_ERROR: "Please provide a valid email address",
  GENERIC_ERROR_MESSAGE: "Something went wrong. Please try again.",
  POST_A_COMMENT: "Post a comment",
  SHOW_ALL_COMMENTS: "Show all comments",
  COMMENTS: "Comments",
});

export const FOLLOW_US_ICONS = [
  { type: "follow-facebook", label: "Follow Facebook", urlKey: "facebook-url" },
  { type: "follow-x", label: "Follow X", urlKey: "twitter-url" },
  { type: "follow-youtube", label: "Follow Youtube", urlKey: "youtube-url" },
  { type: "follow-instagram", label: "Follow Instagram", urlKey: "instagram-url" },
];

export const LOGO_BASE_SIZE = {
  dimensions: {
    width: "119",
    height: "38.31",
  },
};

export const BUTTONS_DATA = [
  {
    iconType: "summary",
    text: STATIC_KEYWORDS.SUMMARY,
  },
  {
    ariaLabel: "Share story button",
  },
];

export const PAYWALL_BUTTONS = [
  { id: 1, label: "Google", iconType: "google" },
  { id: 2, label: "Facebook", iconType: "follow-facebook" },
];

export const NO_STORIES = "No Stories Found!";
export const NO_STORIES_AUTHOR_PAGE = "No stories available from this author.";
export const ALLOWED_SOCIAL_HANDLES = ["facebook", "twitter", "instagram"];

// required to fetch entities in homepage.
export const TEMPLATE_NAMES = [
  "Fortune500India",
  "Next500India",
  "BestBSchools",
  "MostPowerfulWomen",
  "FortyUnderForty",
  "EmergingCompanies",
  "TrendingPeople",
  "top100Billionaires",
];
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const YEARS = [
  2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035,
  2036, 2037,
];

export const FALLBACK_IMAGE =
  "https://media.fortuneindia.com/fortuneindia-uat/2025-07-21/cyhsz12n/fallback-image.svg?auto=format,compress";

export const validKeysBSchools = ["overall", "zone", "city", "private", "university", "non-university", "government"];

export const ABOUT_THE_AUTHOR_TITLE = "ABOUT THE AUTHOR(S)";

export const rankLabelsBSchools = {
  zone: "ZONAL RANK",
  city: "CITY RANK",
  private: "PRIVATE RANK",
  overall: "RANK",
  university: "UNIVERSITY RANK",
  "non-university": "NON UNIVERSITY RANK",
  government: "GOVERNMENT RANK",
};

export const NOT_FOUND_CONTENT = {
  status: "404",
  notFoundMessage: "Page Not Found",
  notFoundDescription: "We're sorry, the page you’re looking for doesn't exist",
  backToHome: "Back to Home",
};

export const RANK_PRIORITY = {
  "Fortune 500 India": 4,
  "The Next 500": 3,
  "Most Powerful Women": 2,
  "40 Under 40": 1,
};
